import { render, staticRenderFns } from "./subscription-purchase-end.vue?vue&type=template&id=54036fa1&scoped=true&"
import script from "./subscription-purchase-end.vue?vue&type=script&lang=js&"
export * from "./subscription-purchase-end.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54036fa1",
  null
  
)

export default component.exports